import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-striped table-hover" }
const _hoisted_6 = { class: "badge bg-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_delete_button = _resolveComponent("bs5-delete-button")!
  const _component_bs5_group_button = _resolveComponent("bs5-group-button")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!

  return (_openBlock(), _createBlock(_component_bs5_base_modal, {
    title: "Client Licenses",
    visible: _ctx.visible,
    width: "80%",
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1)
          ])))
        : (_ctx.licenses.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
              _createElementVNode("p", null, "No licenses found.", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("table", _hoisted_5, [
                  _cache[4] || (_cache[4] = _createElementVNode("thead", { class: "table-dark" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "#"),
                      _createElementVNode("th", null, "Issued Date"),
                      _createElementVNode("th", null, "Expire Date"),
                      _createElementVNode("th", null, "Status"),
                      _createElementVNode("th", null, "License Key"),
                      _createElementVNode("th", null, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenses, (license, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: license.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(license.issuedDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(license.expireDate ? _ctx.formatDate(license.expireDate) : "Never"), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", license.isActive ? 'bg-success' : 'bg-danger'])
                          }, _toDisplayString(license.isActive ? "Active" : "Inactive"), 3)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(license.licenseKey), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_bs5_group_button, null, {
                            default: _withCtx(() => [
                              (license.isActive)
                                ? (_openBlock(), _createBlock(_component_bs5_save_button, {
                                    key: 0,
                                    variant: "info",
                                    onClick: ($event: any) => (_ctx.downloadLicense(_ctx.clientId, license.id))
                                  }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                      _createTextVNode("Download")
                                    ])),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (license.isActive)
                                ? (_openBlock(), _createBlock(_component_bs5_delete_button, {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.deleteLicense(_ctx.clientId, license.id))
                                  }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                      _createTextVNode("Delete")
                                    ])),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("Close")
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}